import { Box, Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

import { ManagementLogForm } from './ManagementLogForm'
import { ManagementLogTable } from './ManagementLogTable'
import { HeaderSection } from './HeaderSection'

export const ManagementLog = ({ useFetchInit, readOnlyMode }) => {

    const { Actions } = useFetchInit
    const { handleClickReturnStep, handleClickNextStep } = Actions

    return (
        <>
            <HeaderSection useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />
            <div className="pt-2"></div>
            <ManagementLogForm useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />
            <div className="pt-2"></div>
            <ManagementLogTable useFetchInit={useFetchInit} readOnlyMode={readOnlyMode} />

            <div className="pt-4"></div>
            <Box className="text-center" sx={{mt: 2}}>
                <Button 
                    variant="contained"
                    type="button"
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                >
                    <ArrowLeftCircle/>
                </Button>
                <Button
                    variant="contained"
                    type='button'
                    onClick={handleClickNextStep}
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                >
                    <ArrowRightCircle/>
                </Button>
            </Box>
        </>
    )
}
